export const Gmedia = [
    {type: 'image', url: require('../../../assets/Gaurav_pandey/1.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/2.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/3.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/4.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/5.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/6.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/7.webp')},
    {type: 'image', url: require('../../../assets/Gaurav_pandey/8.webp')},
]